// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
.du-card {
  border-radius: 12px;
  background: #fff;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 0.75rem;
}
.du-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 16px;
  background: linear-gradient(135deg, #f5f0ff 0%, #faf8ff 100%);
  border-bottom: 1px solid rgba(93, 77, 128, 0.08);
}
.du-source-tag {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #5d4d80;
}
.du-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.du-auth-score {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.2);
}
.du-auth-score.du-score-warn {
  background: #fffbeb;
  color: #ea580c;
  border-color: rgba(234, 136, 12, 0.2);
}
.du-auth-score.du-score-fail {
  background: #fef2f2;
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.2);
}
.du-auth-status {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 999px;
  background: #f5f5f5;
  color: #a3a3a3;
  border: 1px solid #ededed;
  text-transform: capitalize;
}
.du-auth-status.du-status-pass {
  background: #f0fdf4;
  color: #16a34a;
  border-color: rgba(22, 163, 74, 0.2);
}
.du-auth-status.du-status-fail {
  background: #fef2f2;
  color: #dc2626;
  border-color: rgba(220, 38, 38, 0.2);
}
.du-download-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid rgba(93, 77, 128, 0.2);
  background: #fff;
  font-size: 0.68rem;
  font-weight: 600;
  color: #5d4d80;
  cursor: pointer;
  transition: background 120ms ease, border-color 120ms ease;
}
.du-download-btn:hover:not(:disabled) {
  background: #f5f0ff;
  border-color: #5d4d80;
}
.du-download-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.du-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 16px;
}
.du-hero-left {
  flex: 1;
  min-width: 0;
}
.du-source-name {
  font-size: 1.15rem;
  font-weight: 700;
  color: #171717;
  line-height: 1.3;
}
.du-applicant-line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-top: 6px;
  font-size: 0.78rem;
  color: #a3a3a3;
}
.du-name-match {
  font-size: 1rem;
  line-height: 1;
  margin-top: 2px;
}
.du-match-yes {
  color: #16a34a;
}
.du-match-no {
  color: #dc2626;
}
.du-name-rows {
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.du-name-row {
  display: flex;
  align-items: baseline;
  gap: 5px;
}
.du-applicant-label {
  font-weight: 600;
  color: #a3a3a3;
  font-size: 0.72rem;
}
.du-applicant-value {
  font-weight: 700;
  color: #171717;
  font-size: 0.82rem;
}
.du-hero-right {
  flex-shrink: 0;
  text-align: right;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f5f0ff 0%, #f0f9ff 100%);
  border-radius: 6px;
  border: 1px solid rgba(93, 77, 128, 0.12);
}
.du-hero-amount {
  font-size: 1.65rem;
  font-weight: 800;
  color: #5d4d80;
  line-height: 1.1;
  letter-spacing: -0.02em;
}
.du-hero-label {
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3a3a3;
  margin-top: 1px;
}
.du-doc-details {
  padding: 0 16px 12px;
}
.du-detail-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  padding: 4px 0;
}
.du-detail-row + .du-detail-row {
  border-top: 1px solid #f5f5f5;
}
.du-detail-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #a3a3a3;
  min-width: 110px;
}
.du-detail-value {
  font-size: 0.85rem;
  font-weight: 700;
  color: #171717;
}
.du-paystubs {
  padding: 12px 16px;
  border-top: 1px solid #ededed;
}
.du-paystubs-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.du-paystubs-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #171717;
}
.du-paystubs-seq {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 999px;
}
.du-seq-pass {
  background: #f0fdf4;
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.2);
}
.du-seq-fail {
  background: #fffbeb;
  color: #ea580c;
  border: 1px solid rgba(234, 136, 12, 0.2);
}
.du-stub {
  padding: 8px 10px;
  border: 1px solid #ededed;
  border-radius: 6px;
  margin-bottom: 6px;
  background: #fff;
}
.du-stub:last-child {
  margin-bottom: 0;
}
.du-stub-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.78rem;
}
.du-stub-row + .du-stub-row {
  margin-top: 4px;
}
.du-stub-num {
  font-weight: 700;
  color: #a3a3a3;
  min-width: 20px;
}
.du-stub-period {
  font-weight: 600;
  color: #171717;
}
.du-stub-paydate {
  color: #a3a3a3;
  margin-left: auto;
}
.du-stub-name {
  font-weight: 600;
}
.du-stub-amounts {
  margin-left: auto;
  color: #171717;
  font-weight: 600;
}
.du-stub-auth-row {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #ededed;
  gap: 8px;
}
.du-stub-score {
  font-weight: 700;
  font-size: 0.72rem;
  padding: 2px 6px;
  border-radius: 3px;
}
.du-score-pass {
  background: #dcfce7;
  color: #16a34a;
}
.du-score-warn {
  background: #fff7ed;
  color: #ea580c;
}
.du-score-fail {
  background: #fef2f2;
  color: #dc2626;
}
.du-stub-classification,
.du-stub-auth-status {
  font-size: 0.7rem;
  color: #a3a3a3;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.du-stub-overlay-btn,
.du-stub-download-btn {
  font-size: 0.7rem;
  font-weight: 600;
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 3px;
  padding: 1px 8px;
  cursor: pointer;
  margin-left: auto;
  transition: background 120ms ease;
}
.du-stub-overlay-btn:hover:not(:disabled),
.du-stub-download-btn:hover:not(:disabled) {
  background: #f5f5f5;
}
.du-stub-overlay-btn:disabled,
.du-stub-download-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.du-stub-overlay-btn.active,
.du-stub-download-btn.active {
  background: #005ff0;
  color: #fff;
  border-color: #005ff0;
}
.du-stub-download-btn {
  margin-left: 4px;
}
.du-stub-fraud {
  margin-top: 6px;
  padding: 6px 8px;
  background: #fef2f2;
  border-radius: 6px;
  border-left: 3px solid #dc2626;
}
.du-stub-signal {
  font-size: 0.72rem;
  color: #dc2626;
  line-height: 1.4;
  padding: 1px 0;
}
.du-stub-signal strong {
  font-weight: 700;
}
.du-stub-overlay-viewer {
  margin-top: 8px;
  border-radius: 6px;
  overflow: hidden;
  background: #f5f5f5;
  min-height: 40px;
}
.du-divider {
  margin: 0;
  border: none;
  border-top: 1px solid #ededed;
}
.du-fraud-section {
  padding: 12px 16px;
}
.du-fraud-section .alert {
  font-size: 0.82rem;
  font-weight: 600;
  padding: 10px 14px;
  margin-bottom: 8px;
  border-radius: 6px;
}
.du-fraud-section .alert:last-child {
  margin-bottom: 0;
}
.du-fraud-section .alert-danger {
  background: #fef2f2;
  border: 1px solid rgba(220, 38, 38, 0.2);
  color: #dc2626;
}
.du-fraud-section .alert-success {
  background: #f0fdf4;
  border: 1px solid rgba(22, 163, 74, 0.2);
  color: #16a34a;
}
.du-overlay-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 16px;
  border-top: 1px solid #ededed;
}
.du-overlay-bar .btn {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 999px;
}
.du-overlay-viewer {
  padding: 12px 16px;
  text-align: center;
  border-top: 1px solid #ededed;
  background: #fafafa;
}
.du-overlay-loading {
  font-size: 0.82rem;
  color: #a3a3a3;
  padding: 16px 0;
}
.du-overlay-img {
  max-width: 100%;
  border-radius: 6px;
  border: 1px solid #ededed;
}
.du-file-info {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border-top: 1px solid #ededed;
  font-size: 0.72rem;
  color: #a3a3a3;
}
.du-file-icon {
  font-size: 0.9rem;
}
.du-file-name {
  font-weight: 600;
}
.du-invalid-banner {
  padding: 0 16px;
  margin-top: 12px;
}
.du-invalid-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 2px solid #dc3545;
  border-radius: 8px;
  padding: 16px;
  background: #fff5f5;
}
.du-invalid-alert .du-invalid-icon {
  font-size: 2rem;
  line-height: 1;
}
.du-invalid-alert .du-invalid-content strong {
  font-size: 1.1rem;
  color: #dc3545;
}
.du-invalid-alert .du-invalid-content p {
  margin: 4px 0 0;
  font-size: 0.85rem;
  color: #333;
}
.du-invalid-alert .du-invalid-content .du-invalid-hint {
  font-style: italic;
  color: #666;
}
.du-stub-invalid {
  opacity: 0.7;
  border-left: 3px solid #dc3545;
  background: #fff9f9;
}
.du-stub-invalid-tag {
  font-size: 0.75rem;
  font-weight: 600;
  color: #dc3545;
  padding: 2px 8px 4px;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/income-wizard/phases/stream-phase/stream-types/docupload-wizard-detail.component.less"],"names":[],"mappings":"AAaA;EAAQ,cAAA;EAAgB,WAAA;AAVxB;AAYA;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,yEAAA;EACA,gBAAA;EACA,sBAAA;AAVF;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,6DAAA;EACA,gDAAA;AAZF;AAeA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAdF;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,wCAAA;AAfF;AAiBE;EACE,mBAAA;EACA,cAAA;EACA,qCAAA;AAfJ;AAkBE;EACE,mBAAA;EACA,cAAA;EACA,oCAAA;AAhBJ;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;EACA,0BAAA;AAlBF;AAoBE;EACE,mBAAA;EACA,cAAA;EACA,oCAAA;AAlBJ;AAqBE;EACE,mBAAA;EACA,cAAA;EACA,oCAAA;AAnBJ;AAuBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,0DAAA;AArBF;AAuBE;EACE,mBAAA;EACA,qBAAA;AArBJ;AAwBE;EAAa,aAAA;EAAe,mBAAA;AApB9B;AAwBA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAtBF;AAyBA;EAAgB,OAAA;EAAS,YAAA;AArBzB;AAuBA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AArBF;AAyBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAvBF;AA0BA;EAAiB,eAAA;EAAiB,cAAA;EAAgB,eAAA;AArBlD;AAsBA;EAAgB,cAAA;AAnBhB;AAoBA;EAAe,cAAA;AAjBf;AAkBA;EAAgB,aAAA;EAAe,sBAAA;EAAwB,QAAA;AAbvD;AAcA;EAAe,aAAA;EAAe,qBAAA;EAAuB,QAAA;AATrD;AAUA;EAAsB,gBAAA;EAAkB,cAAA;EAAwB,kBAAA;AALhE;AAMA;EAAsB,gBAAA;EAAkB,cAAA;EAAyB,kBAAA;AADjE;AAIA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,6DAAA;EACA,kBAAA;EACA,yCAAA;AAFF;AAKA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,uBAAA;AAHF;AAMA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;AAJF;AAQA;EACE,oBAAA;AANF;AASA;EACE,aAAA;EACA,qBAAA;EACA,QAAA;EACA,cAAA;AAPF;AASE;EACE,6BAAA;AAPJ;AAWA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AATF;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;AAVF;AAcA;EACE,kBAAA;EACA,6BAAA;AAZF;AAeA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AAbF;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;AAdF;AAiBA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;AAfF;AAkBA;EACE,mBAAA;EACA,cAAA;EACA,wCAAA;AAhBF;AAmBA;EACE,mBAAA;EACA,cAAA;EACA,yCAAA;AAjBF;AAoBA;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AAlBF;AAoBE;EAAe,gBAAA;AAjBjB;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAlBF;AAoBE;EAAmB,eAAA;AAjBrB;AAoBA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAlBF;AAqBA;EACE,gBAAA;EACA,cAAA;AAnBF;AAsBA;EACE,cAAA;EACA,iBAAA;AApBF;AAuBA;EACE,gBAAA;AArBF;AAwBA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AAtBF;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,QAAA;AAxBF;AA2BA;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAzBF;AA4BA;EAAiB,mBAAA;EAAqB,cAAA;AAxBtC;AAyBA;EAAiB,mBAAA;EAAqB,cAAA;AArBtC;AAsBA;EAAiB,mBAAA;EAAqB,cAAA;AAlBtC;AAoBA;;EAEE,iBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAlBF;AAqBA;;EAEE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;AAnBF;AAqBE;;EAAyB,mBAAA;AAjB3B;AAkBE;;EAAa,YAAA;EAAc,mBAAA;AAb7B;AAcE;;EAAW,mBAAA;EAA0B,WAAA;EAAa,qBAAA;AARpD;AAWA;EAAwB,gBAAA;AARxB;AAWA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,8BAAA;AATF;AAYA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;AAVF;AAMA;EAMW,gBAAA;AATX;AAaA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAXF;AAeA;EACE,SAAA;EACA,YAAA;EACA,6BAAA;AAbF;AAiBA;EACE,kBAAA;AAfF;AAcA;EAII,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAfJ;AAiBI;EAAe,gBAAA;AAdnB;AAIA;EAcI,mBAAA;EACA,wCAAA;EACA,cAAA;AAfJ;AADA;EAoBI,mBAAA;EACA,wCAAA;EACA,cAAA;AAhBJ;AAqBA;EACE,aAAA;EACA,eAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AAnBF;AAcA;EAQI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAnBJ;AAwBA;EACE,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,mBAAA;AAtBF;AAyBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;AAvBF;AA0BA;EACE,eAAA;EACA,kBAAA;EACA,yBAAA;AAxBF;AA4BA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,cAAA;AA1BF;AA6BA;EAAgB,iBAAA;AA1BhB;AA2BA;EAAgB,gBAAA;AAxBhB;AA2BA;EACE,eAAA;EACA,gBAAA;AAzBF;AA4BA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AA1BF;AAmBA;EAUI,eAAA;EACA,cAAA;AA1BJ;AAeA;EAgBM,iBAAA;EACA,cAAA;AA5BN;AAWA;EAoBM,eAAA;EACA,kBAAA;EACA,WAAA;AA5BN;AAMA;EAyBM,kBAAA;EACA,WAAA;AA5BN;AAiCA;EACE,YAAA;EACA,8BAAA;EACA,mBAAA;AA/BF;AAkCA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAhCF","sourcesContent":["@uds-blue-70: #005ff0;\n@uds-green-70: #16a34a;\n@uds-red-70: #dc2626;\n@uds-orange-70: #ea580c;\n@uds-neutral-10: #fafafa;\n@uds-neutral-20: #f5f5f5;\n@uds-neutral-30: #ededed;\n@uds-neutral-50: #a3a3a3;\n@uds-neutral-100: #171717;\n@uds-radius: 12px;\n@uds-radius-sm: 6px;\n@uds-ease: 120ms ease;\n\n:host { display: block; width: 100%; }\n\n.du-card {\n  border-radius: @uds-radius;\n  background: #fff;\n  border: 1px solid @uds-neutral-30;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.03);\n  overflow: hidden;\n  margin-bottom: 0.75rem;\n}\n\n// ── Header ──\n.du-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 16px;\n  background: linear-gradient(135deg, #f5f0ff 0%, #faf8ff 100%);\n  border-bottom: 1px solid rgba(93, 77, 128, 0.08);\n}\n\n.du-source-tag {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #5d4d80;\n}\n\n.du-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.du-auth-score {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: #f0fdf4;\n  color: @uds-green-70;\n  border: 1px solid rgba(22, 163, 74, 0.2);\n\n  &.du-score-warn {\n    background: #fffbeb;\n    color: @uds-orange-70;\n    border-color: rgba(234, 136, 12, 0.2);\n  }\n\n  &.du-score-fail {\n    background: #fef2f2;\n    color: @uds-red-70;\n    border-color: rgba(220, 38, 38, 0.2);\n  }\n}\n\n.du-auth-status {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 999px;\n  background: @uds-neutral-20;\n  color: @uds-neutral-50;\n  border: 1px solid @uds-neutral-30;\n  text-transform: capitalize;\n\n  &.du-status-pass {\n    background: #f0fdf4;\n    color: @uds-green-70;\n    border-color: rgba(22, 163, 74, 0.2);\n  }\n\n  &.du-status-fail {\n    background: #fef2f2;\n    color: @uds-red-70;\n    border-color: rgba(220, 38, 38, 0.2);\n  }\n}\n\n.du-download-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(93, 77, 128, 0.2);\n  background: #fff;\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: #5d4d80;\n  cursor: pointer;\n  transition: background @uds-ease, border-color @uds-ease;\n\n  &:hover:not(:disabled) {\n    background: #f5f0ff;\n    border-color: #5d4d80;\n  }\n\n  &:disabled { opacity: 0.45; cursor: not-allowed; }\n}\n\n// ── Hero ──\n.du-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 16px;\n}\n\n.du-hero-left { flex: 1; min-width: 0; }\n\n.du-source-name {\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n  line-height: 1.3;\n}\n\n// ── Applicant match ──\n.du-applicant-line {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-top: 6px;\n  font-size: 0.78rem;\n  color: @uds-neutral-50;\n}\n\n.du-name-match { font-size: 1rem; line-height: 1; margin-top: 2px; }\n.du-match-yes { color: @uds-green-70; }\n.du-match-no { color: @uds-red-70; }\n.du-name-rows { display: flex; flex-direction: column; gap: 1px; }\n.du-name-row { display: flex; align-items: baseline; gap: 5px; }\n.du-applicant-label { font-weight: 600; color: @uds-neutral-50; font-size: 0.72rem; }\n.du-applicant-value { font-weight: 700; color: @uds-neutral-100; font-size: 0.82rem; }\n\n// ── Hero amount ──\n.du-hero-right {\n  flex-shrink: 0;\n  text-align: right;\n  padding: 10px 14px;\n  background: linear-gradient(135deg, #f5f0ff 0%, #f0f9ff 100%);\n  border-radius: @uds-radius-sm;\n  border: 1px solid rgba(93, 77, 128, 0.12);\n}\n\n.du-hero-amount {\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: #5d4d80;\n  line-height: 1.1;\n  letter-spacing: -0.02em;\n}\n\n.du-hero-label {\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-50;\n  margin-top: 1px;\n}\n\n// ── Document details (type-specific) ──\n.du-doc-details {\n  padding: 0 16px 12px;\n}\n\n.du-detail-row {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  padding: 4px 0;\n\n  & + .du-detail-row {\n    border-top: 1px solid @uds-neutral-20;\n  }\n}\n\n.du-detail-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: @uds-neutral-50;\n  min-width: 110px;\n}\n\n.du-detail-value {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: @uds-neutral-100;\n}\n\n// ── Paystub list ──\n.du-paystubs {\n  padding: 12px 16px;\n  border-top: 1px solid @uds-neutral-30;\n}\n\n.du-paystubs-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.du-paystubs-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: @uds-neutral-100;\n}\n\n.du-paystubs-seq {\n  font-size: 0.72rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 999px;\n}\n\n.du-seq-pass {\n  background: #f0fdf4;\n  color: @uds-green-70;\n  border: 1px solid rgba(22, 163, 74, 0.2);\n}\n\n.du-seq-fail {\n  background: #fffbeb;\n  color: @uds-orange-70;\n  border: 1px solid rgba(234, 136, 12, 0.2);\n}\n\n.du-stub {\n  padding: 8px 10px;\n  border: 1px solid @uds-neutral-30;\n  border-radius: @uds-radius-sm;\n  margin-bottom: 6px;\n  background: #fff;\n\n  &:last-child { margin-bottom: 0; }\n}\n\n.du-stub-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.78rem;\n\n  & + .du-stub-row { margin-top: 4px; }\n}\n\n.du-stub-num {\n  font-weight: 700;\n  color: @uds-neutral-50;\n  min-width: 20px;\n}\n\n.du-stub-period {\n  font-weight: 600;\n  color: @uds-neutral-100;\n}\n\n.du-stub-paydate {\n  color: @uds-neutral-50;\n  margin-left: auto;\n}\n\n.du-stub-name {\n  font-weight: 600;\n}\n\n.du-stub-amounts {\n  margin-left: auto;\n  color: @uds-neutral-100;\n  font-weight: 600;\n}\n\n// ── Per-stub authenticity row ──\n.du-stub-auth-row {\n  margin-top: 6px;\n  padding-top: 6px;\n  border-top: 1px dashed @uds-neutral-30;\n  gap: 8px;\n}\n\n.du-stub-score {\n  font-weight: 700;\n  font-size: 0.72rem;\n  padding: 2px 6px;\n  border-radius: 3px;\n}\n\n.du-score-pass { background: #dcfce7; color: @uds-green-70; }\n.du-score-warn { background: #fff7ed; color: @uds-orange-70; }\n.du-score-fail { background: #fef2f2; color: @uds-red-70; }\n\n.du-stub-classification,\n.du-stub-auth-status {\n  font-size: 0.7rem;\n  color: @uds-neutral-50;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.du-stub-overlay-btn,\n.du-stub-download-btn {\n  font-size: 0.7rem;\n  font-weight: 600;\n  background: @uds-neutral-10;\n  border: 1px solid @uds-neutral-30;\n  border-radius: 3px;\n  padding: 1px 8px;\n  cursor: pointer;\n  margin-left: auto;\n  transition: background @uds-ease;\n\n  &:hover:not(:disabled) { background: @uds-neutral-20; }\n  &:disabled { opacity: 0.5; cursor: not-allowed; }\n  &.active { background: @uds-blue-70; color: #fff; border-color: @uds-blue-70; }\n}\n\n.du-stub-download-btn { margin-left: 4px; }\n\n// ── Per-stub fraud signals ──\n.du-stub-fraud {\n  margin-top: 6px;\n  padding: 6px 8px;\n  background: #fef2f2;\n  border-radius: @uds-radius-sm;\n  border-left: 3px solid @uds-red-70;\n}\n\n.du-stub-signal {\n  font-size: 0.72rem;\n  color: @uds-red-70;\n  line-height: 1.4;\n  padding: 1px 0;\n\n  strong { font-weight: 700; }\n}\n\n// ── Per-stub overlay ──\n.du-stub-overlay-viewer {\n  margin-top: 8px;\n  border-radius: @uds-radius-sm;\n  overflow: hidden;\n  background: @uds-neutral-20;\n  min-height: 40px;\n}\n\n// ── Divider ──\n.du-divider {\n  margin: 0;\n  border: none;\n  border-top: 1px solid @uds-neutral-30;\n}\n\n// ── Fraud section (matches original alert style) ──\n.du-fraud-section {\n  padding: 12px 16px;\n\n  .alert {\n    font-size: 0.82rem;\n    font-weight: 600;\n    padding: 10px 14px;\n    margin-bottom: 8px;\n    border-radius: @uds-radius-sm;\n\n    &:last-child { margin-bottom: 0; }\n  }\n\n  .alert-danger {\n    background: #fef2f2;\n    border: 1px solid rgba(220, 38, 38, 0.2);\n    color: @uds-red-70;\n  }\n\n  .alert-success {\n    background: #f0fdf4;\n    border: 1px solid rgba(22, 163, 74, 0.2);\n    color: @uds-green-70;\n  }\n}\n\n// ── Overlay bar ──\n.du-overlay-bar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  padding: 10px 16px;\n  border-top: 1px solid @uds-neutral-30;\n\n  .btn {\n    font-size: 0.72rem;\n    font-weight: 600;\n    padding: 4px 12px;\n    border-radius: 999px;\n  }\n}\n\n// ── Overlay viewer ──\n.du-overlay-viewer {\n  padding: 12px 16px;\n  text-align: center;\n  border-top: 1px solid @uds-neutral-30;\n  background: @uds-neutral-10;\n}\n\n.du-overlay-loading {\n  font-size: 0.82rem;\n  color: @uds-neutral-50;\n  padding: 16px 0;\n}\n\n.du-overlay-img {\n  max-width: 100%;\n  border-radius: @uds-radius-sm;\n  border: 1px solid @uds-neutral-30;\n}\n\n// ── File info ──\n.du-file-info {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  border-top: 1px solid @uds-neutral-30;\n  font-size: 0.72rem;\n  color: @uds-neutral-50;\n}\n\n.du-file-icon { font-size: 0.9rem; }\n.du-file-name { font-weight: 600; }\n\n// Invalid document states\n.du-invalid-banner {\n  padding: 0 16px;\n  margin-top: 12px;\n}\n\n.du-invalid-alert {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  border: 2px solid #dc3545;\n  border-radius: 8px;\n  padding: 16px;\n  background: #fff5f5;\n\n  .du-invalid-icon {\n    font-size: 2rem;\n    line-height: 1;\n  }\n\n  .du-invalid-content {\n    strong {\n      font-size: 1.1rem;\n      color: #dc3545;\n    }\n    p {\n      margin: 4px 0 0;\n      font-size: 0.85rem;\n      color: #333;\n    }\n    .du-invalid-hint {\n      font-style: italic;\n      color: #666;\n    }\n  }\n}\n\n.du-stub-invalid {\n  opacity: 0.7;\n  border-left: 3px solid #dc3545;\n  background: #fff9f9;\n}\n\n.du-stub-invalid-tag {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #dc3545;\n  padding: 2px 8px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
